import { IEnv } from '../app/core/interface/app.interface';

export const environment: IEnv = {
  production: false,
  phase: import.meta.env.NG_APP_X_PHASE,
  conversationLimit: import.meta.env.NG_APP_CONVERSATION_LIMIT,
  loggingEnabled: true,
  deliveryWebUrl: import.meta.env.NG_APP_DELIVERY_WEB_URL,
  googleMapsApiKey: import.meta.env.NG_APP_GOOGLE_MAPS_API_KEY,
  api: {
    baseUrl: import.meta.env.NG_APP_API_URL,
  },
  app: {
    domain: import.meta.env.NG_APP_APP_DOMAIN,
  },
  delivery: {
    domain: import.meta.env.NG_APP_DELIVERY_DOMAIN,
  },
  commerce: {
    domain: import.meta.env.NG_APP_COMMERCE_DOMAIN,
  },
  auth0: {
    domain: import.meta.env.NG_APP_AUTH0_DOMAIN,
    clientId: import.meta.env.NG_APP_AUTH0_CLIENT_ID,
    authorizationParams: {
      redirect_uri: import.meta.env.NG_APP_AUTH0_REDIRECT_URI,
      audience: import.meta.env.NG_APP_AUTH0_AUDIENCE,
    },
  },
  s3: {
    fileBlob: import.meta.env.NG_APP_S3_FILE_BLOB,
    pubBlob: import.meta.env.NG_APP_S3_PUB_BLOB,
    snapBlob: import.meta.env.NG_APP_S3_SNAP_BLOB,
    ingestBlob: import.meta.env.NG_APP_S3_INGEST_BLOB,
    egressBlob: import.meta.env.NG_APP_S3_EGRESS_BLOB,
  },
};
